<template>
  <div class="row">
    <div class="col-lg-10">
      <h2>Vehicle Registration</h2>
    </div>
    <div class="col-lg-2 text-right">
      <router-link to="/Fleet/RegisterVehicle">
        <base-button type="primary">Register Vehicle</base-button>
      </router-link>
    </div>
    <div class="col-lg-8">
      <card type="chart">
        <template slot="header">
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Total Monthly Registration</b>
          </h3>
        </template>
        <div class="chart">
          <line-chart
            v-if="monthlyVehicleChart.loaded"
            :chart-data="monthlyVehicleChart.chartData"
            :gradient-colors="monthlyVehicleChart.gradientColors"
            :gradient-stops="monthlyVehicleChart.gradientStops"
            :extra-options="monthlyVehicleChart.extraOptions"
            style="height: 190%"
          ></line-chart>
        </div>
      </card>
    </div>
    <div class="col-lg-4 d-flex">
      <card card-body-classes="table-full-width">
        <el-table :data="tableCategory" height="450"  :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }">
          <el-table-column :min-width="80" label="#">
            <img :src="carIcon" style="width: 40px" />
          </el-table-column>
          <el-table-column :min-width="150" prop="category" label="Category"></el-table-column>
          <el-table-column :min-width="90" prop="percent" label="Percent"></el-table-column>
        </el-table>
      </card>
    </div>

    <div class="col-lg-12">
      <card type="chart">
        <template slot="header">
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Total no of Fleets</b>
          </h3>
        </template>
        <div class="chart">
          <bar-chart
            v-if="totalFleetChart.loaded"
            :chart-data="totalFleetChart.chartData"
            :extra-options="totalFleetChart.extraOptions"
            :gradient-colors="totalFleetChart.gradientColors"
            :gradient-stops="totalFleetChart.gradientStops"
            style="height: 140%"
          ></bar-chart>
        </div>
      </card>
    </div>
    <div class="col-12">
      <card card-body-classes="table-full-width">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-3">
              <h3>List of Vehicle</h3>
            </div>
            <div class="col-lg-9 text-right">
              <base-button
                @click="exportCSV(tableVehicle)"
                simple
                native-type="submit"
                type="success"
                style="margin-left: 2%"
              >Export to CSV</base-button>
            </div>
          </div>
        </div>
        <div>
          <div class="col-lg-12">
            <div class="row">
              <div class="col-2">
                <base-input label="rows visible">
                <el-select
                  class="select-info mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-info"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                </base-input>
              </div>
              <div class="col-8 text-center" style=" margin-bottom: 1%">
                <base-checkbox inline class="mb-3" v-model="checkboxes.vehicleno">Vehicle No</base-checkbox>
                <base-checkbox inline class="mb-3" v-model="checkboxes.vehiclecategory">Category</base-checkbox>
                <base-checkbox inline class="mb-3" v-model="checkboxes.vehiclebdm">BDM</base-checkbox>
                <base-checkbox inline class="mb-3" v-model="checkboxes.vehiclebtm">BTM</base-checkbox>
                <base-checkbox inline class="mb-3" v-model="checkboxes.vehiclemodel">Model</base-checkbox>
                <base-checkbox inline class="mb-3" v-model="checkboxes.vehiclesize">Size</base-checkbox>
                <base-checkbox inline class="mb-3" v-model="checkboxes.vehiclechass">Chassis No</base-checkbox>
                <base-checkbox inline class="mb-3" v-model="checkboxes.vehicleng">Engine No</base-checkbox>
                <base-checkbox inline class="mb-3" v-model="checkboxes.VehicleStatus">Status</base-checkbox>
              </div>
              <div class="col-2">
                <base-input>
                  <el-input
                    type="search"
                    class="mb-3 search-input"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="Search records"
                    v-model="searchQuery"
                    aria-controls="datatables"
                  ></el-input>
                </base-input>
              </div>
            </div>
          </div>

          <el-table :data="queriedData"  :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }">
            <el-table-column
              v-if="checkboxes.vehicleno"
              :min-width="150"
              prop="vehicleno"
              label="Vehicle No"
            ></el-table-column>
            <el-table-column
              v-if="checkboxes.vehiclecategory"
              :min-width="150"
              prop="vehiclecategory"
              label="Category"
            ></el-table-column>
            <el-table-column
              v-if="checkboxes.vehiclebdm"
              :min-width="100"
              prop="vehiclebdm"
              label="BDM"
            ></el-table-column>
            <el-table-column
              v-if="checkboxes.vehiclebtm"
              :min-width="100"
              prop="vehiclebtm"
              label="BTM"
            ></el-table-column>
            <el-table-column
              v-if="checkboxes.vehiclemodel"
              :min-width="100"
              prop="vehiclemodel"
              label="Model"
            ></el-table-column>
            <el-table-column
              v-if="checkboxes.vehiclesize"
              :min-width="100"
              prop="vehiclesize"
              label="Size"
            ></el-table-column>
            <el-table-column
              v-if="checkboxes.vehiclechass"
              :min-width="100"
              prop="vehiclechass"
              label="Chassis No"
            ></el-table-column>
            <el-table-column
              v-if="checkboxes.vehicleng"
              :min-width="100"
              prop="vehicleng"
              label="Engine No"
            ></el-table-column>
            <el-table-column
              v-if="checkboxes.VehicleStatus"
              :min-width="100"
              prop="VehicleStatus"
              label="Status"
            ></el-table-column>
            <el-table-column :min-width="80" align="right" label="Actions">
              <div slot-scope="props">
                <el-tooltip content="Edit" placement="bottom" effect="light">
                <base-button
                  @click.native="getRow(props.$index, props.row)"
                  class="edit btn-link"
                  type="info"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-pencil"></i>
                </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import StatsCard from "src/components/Cards/StatsCard";
import config from "@/config";

import { BasePagination, BaseProgress } from "src/components";
import { Table, TableColumn, Select, Option } from "element-ui";
import Fuse from "fuse.js";
import swal from "sweetalert2";

export default {
  components: {
    BaseProgress,
    LineChart,
    BarChart,
    StatsCard,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      checkboxes: {
        vehicleno: true,
        vehiclecategory: true,
        vehiclebdm: true,
        vehiclebtm: true,
        vehiclemodel: true,
        vehiclesize: true,
        vehiclechass: true,
        vehicleng: true,
        VehicleStatus: true
      },
      carIcon: require("@/assets/img/truck.png"),
      tableCategory: [],
      statsCards: [],
      statsCards2: [],
      statsCards3: [],
      totalFleetChart: {
        chartData: {
          labels: [
            "Trash Truck",
            "Sweeper",
            "Recycle Truck",
            "Bin Van",
            "Junk Truck"
          ],
          datasets: [
            {
              label: "Vehicle",
              fill: true,
              borderColor: "rgba(52, 128, 252, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 100, 70, 80, 120, 80, 120]
            }
          ]
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(52, 128, 252, 0.8)",
          "rgba(52, 128, 252, 0.2)",
          "rgba(52, 128, 252, 0.1)"
        ],
        loaded: true,
        gradientStops: [1, 0]
      },

      // Red Line Chart
      monthlyVehicleChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Vehicle",
              fill: true,
              borderColor: "rgba(237, 28, 36, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(237, 28, 36, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: true,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(237, 28, 36, 0.6)",
          "rgba(237, 28, 36, 0.2)",
          "rgba(237, 28, 36, 0.05)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["vehicleno"],
      tableVehicle: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableVehicle;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableVehicle.length;
    }
  },
  methods: {
    getRow(index, row) {
      swal({
        title: "Are you sure?",
        text: `You want to edit ${row.vehicleno}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$router.push({ path: `/Fleet/VehicleUpdate/${row.vehicleno}` });
        }
      });
    },
    getVehicleCategory() {
      this.totalFleetChart.loaded = false;
      this.$http.get(":9993/api/v1/register/category").then(res => {
        if (!res.error) {
          let data = res.message;
          console.log(data)
          let label = [];
          let totalCategory = [];
          let totalVehicle = 0;

          // total no of fleet graph
          for (let i = 0; i < data.length; i++) {
            label.push(data[i].CategoryName);
            totalCategory.push(data[i].Count);
          }

          // fleet percentage table
          for (let i = 0; i < data.length; i++) {
            let name = data[i].CategoryName.split(" ");
            let tableData = {
              percent: data[i].Percentage,
              category: name.length == 1 ? name[0] : `${name[0]} ${name[1]}` // Temporray
            };

            this.tableCategory.push(tableData);
          }

          let chart = {
            chartData: {
              labels: label,
              datasets: [
                {
                  label: "Vehicle",
                  fill: true,
                  borderColor: "rgba(52, 128, 252, 1)",
                  borderWidth: 2,
                  borderDash: [],
                  borderDashOffset: 0.0,
                  data: totalCategory
                }
              ]
            },
            extraOptions: chartConfigs.barChartOptionsGradient,
            gradientColors: [
              "rgba(52, 128, 252, 0.8)",
              "rgba(52, 128, 252, 0.2)",
              "rgba(52, 128, 252, 0.1)"
            ],
            loaded: true,
            gradientStops: [1, 0]
          };

          this.totalFleetChart = chart;
        }
      });
    },
    getMonthlyVehicle() {
      this.monthlyVehicleChart.loaded = false;
      this.$http.get(":9993/api/v1/register/monthlyVehicle").then(res => {
        if (!res.error) {
          let data = res.message;
          console.log(data)
          let label = [];
          let totalVehicle = [];

          for (let i = 0; i < data.length; i++) {
            label.push(data[i].Month);
            totalVehicle.push(data[i].TotalVehicle);
          }

          let chart = {
            chartData: {
              labels: label,
              datasets: [
                {
                  label: "Vehicle",
                  fill: true,
                  borderColor: "rgba(237, 28, 36, 1)",
                  borderWidth: 2,
                  borderDash: [],
                  borderDashOffset: 0.0,
                  pointBackgroundColor: "rgba(237, 28, 36, 1)",
                  pointBorderColor: "rgba(255,255,255,0)",
                  pointHoverBackgroundColor: "#be55ed",
                  pointBorderWidth: 20,
                  pointHoverRadius: 4,
                  pointHoverBorderWidth: 15,
                  pointRadius: 4,
                  data: totalVehicle
                }
              ]
            },
            loaded: true,
            extraOptions: chartConfigs.purpleChartOptions,
            gradientColors: [
              "rgba(237, 28, 36, 0.6)",
              "rgba(237, 28, 36, 0.2)",
              "rgba(237, 28, 36, 0.05)"
            ],
            gradientStops: [1, 0.4, 0]
          };

          this.monthlyVehicleChart = chart;
        }
      });
    },
    getListVehicle() {
      this.$http.get(":9993/api/v1/register/list").then(res => {
        if (!res.error) {
          let data = res.message;
          console.log(data);

          for (let i = 0; i < data.length; i++) {
            let tableData = {
              vehicleno: data[i].VehicleNo,
              vehiclecategory: data[i].CategoryName,
              vehiclebdm: data[i].Bdm,
              vehiclebtm: data[i].Btm,
              vehiclemodel: data[i].Model,
              vehiclesize: data[i].Size,
              vehiclechass: data[i].ChassisNo,
              vehicleng: data[i].EngineNo,
              VehicleStatus: data[i].StatusName
            };

            this.tableVehicle.push(tableData);
          }
        }
      });
    },
    exportCSV(data) {
      let csvData = this.$CSV(this.tableVehicle);
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "VehicleData.csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
  created() {
    this.getVehicleCategory();
    this.getMonthlyVehicle();
    this.getListVehicle();
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableVehicle, {
      keys: ["vehicleno", "vehiclecategory"],
      threshold: 0.3
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableVehicle;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  },

  beforeDestroy() {
    if (this.$rtl.isRTL) {
      this.i18n.locale = "en";
      this.$rtl.disableRTL();
    }
  }
};
</script>
<style lang="scss">
.pagination-select,
.search-input {
  width: 200px;
}
.el-tag.el-tag--info {
  color: white;
}
</style>
